import styled from "styled-components";

import { NoContent } from "components";

export const StyledNoContent = styled(NoContent)`
  min-height: 200px;
`;
